// Featured Video Product functionality
document.addEventListener('DOMContentLoaded', function() {
  const videos = document.querySelectorAll('.featured-video__product video');
  // Click to toggle play/pause
  videos.forEach((video) => {
    console.log(video);
    video.closest('.featured-video__product').addEventListener('click', (e) => {
      if (e.target.closest('.featured-video__product-overlay')) return;
      video.paused ? video.play().catch(() => {}) : video.pause();
      
      // Add active class if video is playing, remove if paused
      const playButton = video.closest('.featured-video__product').querySelector('.play-button');
      if (video.paused) {
        playButton.classList.remove('active');
      } else {
        playButton.classList.add('active');
      }
    });
  });
}); 